import { render } from "./HistogramSlider.vue?vue&type=template&id=44a8cb0c"
import script from "./HistogramSlider.vue?vue&type=script&lang=js"
export * from "./HistogramSlider.vue?vue&type=script&lang=js"

import "./HistogramSlider.vue?vue&type=style&index=0&id=44a8cb0c&lang=css"

import exportComponent from "C:\\Projetos_Codeleader\\vue3-histogram-slider-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__